import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { KienePermissionDirective } from './kiene-permission.directive';

@NgModule({
    declarations: [KienePermissionDirective],

    imports: [CommonModule],
    exports: [KienePermissionDirective],
})
export class DirectivesModule {}
